import React from 'react';
import { useTranslation } from 'react-i18next';
import { WhatYouGetMessages } from './WhatYouGet.messages';
import { TerminalIcon, AiBrainIcon, GlobeIcon, HomeIcon, ChatIcon, ToolsIcon } from '../../design-system/components/SvgIcons';

export const WhatYouGet: React.FC = () => {
  const { t } = useTranslation();

  const items = [
    { icon: <TerminalIcon size={32} />, title: t(WhatYouGetMessages.CLI_TITLE), desc: t(WhatYouGetMessages.CLI_DESC) },
    { icon: <AiBrainIcon size={32} />, title: t(WhatYouGetMessages.PROMPT_TITLE), desc: t(WhatYouGetMessages.PROMPT_DESC) },
    { icon: <GlobeIcon size={32} />, title: t(WhatYouGetMessages.PIPELINE_TITLE), desc: t(WhatYouGetMessages.PIPELINE_DESC) },
    { icon: <HomeIcon size={32} />, title: t(WhatYouGetMessages.DASHBOARD_TITLE), desc: t(WhatYouGetMessages.DASHBOARD_DESC) },
    { icon: <ChatIcon size={32} />, title: t(WhatYouGetMessages.MCP_TITLE), desc: t(WhatYouGetMessages.MCP_DESC) },
    { icon: <ToolsIcon size={32} />, title: t(WhatYouGetMessages.API_TITLE), desc: t(WhatYouGetMessages.API_DESC) },
  ];

  return (
    <section className="what-you-get">
      <div className="container">
        <div className="section-header">
          <h2>{t(WhatYouGetMessages.TITLE)}</h2>
          <p className="section-subtitle">{t(WhatYouGetMessages.SUBTITLE)}</p>
        </div>
        <div className="stack-grid">
          {items.map((item, i) => (
            <div className="stack-card" key={i}>
              <div className="stack-icon">{item.icon}</div>
              <div>
                <div className="stack-title">{item.title}</div>
                <p className="stack-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="stack-included">{t(WhatYouGetMessages.INCLUDED)}</div>
      </div>
    </section>
  );
};
